module.exports = "/_next/static/images/finlord-b5576e253154b2fcf33a0bd30692ccd8.png";